import { Reducer } from 'redux';
import { NotificationsState, NotificationsTypes } from './types';

export const INITIAL_STATE: NotificationsState = {
  notifications: [],
  notificationData: {
    id: '',
    name: '',
    title: '',
    body: '',
    imageUrl: '',
    segmentationId: '',
    topic: '',
    data: '',
    type: 0,
    status: 0,
    createdAt: '',
    updatedAt: '',
  },
  totalCount: 0,
  error: false,
  loading: false,
};

const reducer: Reducer<NotificationsState> = (
  state = INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    // LIST NOTIFICATIONS
    case NotificationsTypes.LIST_NOTIFICATIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        notifications: INITIAL_STATE.notifications,
      };
    case NotificationsTypes.LIST_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        notifications: action.payload.notifications,
        totalCount: action.payload.totalCount,
      };
    case NotificationsTypes.LIST_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        notifications: INITIAL_STATE.notifications,
      };

    // GET NOTIFICATION
    case NotificationsTypes.GET_NOTIFICATION_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        notificationData: INITIAL_STATE.notificationData,
      };
    case NotificationsTypes.GET_NOTIFICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        notificationData: action.payload.notificationData,
      };
    case NotificationsTypes.GET_NOTIFICATION_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        notificationData: INITIAL_STATE.notificationData,
      };

    // CREATE NOTIFICATION
    case NotificationsTypes.CREATE_NOTIFICATION_REQUEST:
      return { ...state, loading: true, error: false };
    case NotificationsTypes.CREATE_NOTIFICATION_SUCCESS:
      return { ...state, loading: false, error: false };
    case NotificationsTypes.CREATE_NOTIFICATION_FAILURE:
      return { ...state, loading: false, error: true };

    // UPDATE NOTIFICATION
    case NotificationsTypes.UPDATE_NOTIFICATION_REQUEST:
      return { ...state, loading: true, error: false };
    case NotificationsTypes.UPDATE_NOTIFICATION_SUCCESS:
      return { ...state, loading: false, error: false };
    case NotificationsTypes.UPDATE_NOTIFICATION_FAILURE:
      return { ...state, loading: false, error: true };

    // DELETE NOTIFICATION
    case NotificationsTypes.DELETE_NOTIFICATION_REQUEST:
      return { ...state, loading: true, error: false };
    case NotificationsTypes.DELETE_NOTIFICATION_SUCCESS:
      return { ...state, loading: false, error: false };
    case NotificationsTypes.DELETE_NOTIFICATION_FAILURE:
      return { ...state, loading: false, error: true };

    // CREATE NOTIFICATIONS
    case NotificationsTypes.CREATE_NOTIFICATIONS_REQUEST:
      return { ...state, loading: true, error: false };
    case NotificationsTypes.CREATE_NOTIFICATIONS_SUCCESS:
      return { ...state, loading: false, error: false };
    case NotificationsTypes.CREATE_NOTIFICATIONS_FAILURE:
      return { ...state, loading: false, error: true };

    // UPDATE NOTIFICATIONS
    case NotificationsTypes.UPDATE_NOTIFICATIONS_REQUEST:
      return { ...state, loading: true, error: false };
    case NotificationsTypes.UPDATE_NOTIFICATIONS_SUCCESS:
      return { ...state, loading: false, error: false };
    case NotificationsTypes.UPDATE_NOTIFICATIONS_FAILURE:
      return { ...state, loading: false, error: true };

    // DELETE NOTIFICATIONS
    case NotificationsTypes.DELETE_NOTIFICATIONS_REQUEST:
      return { ...state, loading: true, error: false };
    case NotificationsTypes.DELETE_NOTIFICATIONS_SUCCESS:
      return { ...state, loading: false, error: false };
    case NotificationsTypes.DELETE_NOTIFICATIONS_FAILURE:
      return { ...state, loading: false, error: true };

    default:
      return state;
  }
};

export default reducer;
